import {
  deleteSavedSearches,
  getSavedSearches,
  markAllProfilesViewed,
  markViewedProfiles,
  postSavedSearch,
  runSavedSearch,
  updateSavedSearchByName,
} from './savedSearch'

const savedSearchApi = {
  postSavedSearch: {
    key: 'POST_SAVED_SEARCH_API_KEY',
    fn: postSavedSearch,
  },
  updateSavedSearchByName: {
    key: 'UPDATE_SAVE_SEARCH_BY_NAME_API_KEY',
    fn: updateSavedSearchByName,
  },
  getSavedSearches: {
    key: 'GET_SAVED_SEARCHES_API_KEY',
    fn: getSavedSearches,
  },
  deleteSavedSearches: {
    key: 'DELETE_SAVED_SEARCHES_API_KEY',
    fn: deleteSavedSearches,
  },
  runSavedSearch: {
    key: 'RUN_SAVED_SEARCH_API_KEY',
    fn: runSavedSearch,
  },
  markViewedProfiles: {
    key: 'MARK_PROFILES_AS_VIEWED_API_KEY',
    fn: markViewedProfiles,
  },
  markAllProfilesViewed: {
    key: 'MARK_ALL_PROFILES_AS_VIEWED_API_KEY',
    fn: markAllProfilesViewed,
  },
}

export default savedSearchApi
